/* global axios */
import ApiClient from '../ApiClient';

// Publicar › Voz da conta (Fase 5): bindings sanitizados do assistente + catálogo de vozes pelo nome.
class PolarisVoiceBindings extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  index(assistantId) {
    return axios.get(`${this.url}/${assistantId}/voice_bindings`);
  }

  update(assistantId, bindingId, params) {
    return axios.patch(
      `${this.url}/${assistantId}/voice_bindings/${bindingId}`,
      params
    );
  }

  catalog() {
    return axios.get(`${this.baseUrl()}/captain/voice_catalog`);
  }
}

export default new PolarisVoiceBindings();
